import ThumbnailPlugin from "../parts/keen-thumbnail-plugin";
import AdaptiveHeight from "../parts/keen-adaptive-height";
import KeenSlider from 'keen-slider';

const images = document.querySelector( '[data-slider="single-post"]' );

if ( images ) {
    const imagesSlider = new KeenSlider( images, {
        slides: {
            spacing: 5
        }
    }, [AdaptiveHeight]);

    const thumbs = document.querySelector( '[data-slider="single-thumbs"]' );

    if ( thumbs ) {
        new KeenSlider(
            thumbs,
            {
                initial: 0,
                slides: {
                    perView: 'auto',
                    spacing: 10,
                },
            },
            [ThumbnailPlugin( imagesSlider )]
        );
    }

};